import { useEffect } from "react";
import { useSelector } from "react-redux";

const useAddressesFields = (getFieldDecorator) => {
	const addresses = useSelector(
		(store) => store.votingStore.addresses.addresses
	);
	useEffect(() => {
		addresses.forEach((company) => {
			company.regions.forEach((region) => {
				region.streets.forEach((street) => {
					street.houses.forEach((house) => {
						getFieldDecorator(`addresses[${house.houseId}]`, {
							initialValue: false,
							preserve: true,
						});
					});
				});
			});
		});
	}, [addresses]);
};

export default useAddressesFields;
